var _circle, _circle2, _circle3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTournamentKnockoutTypeNewGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 46,
    viewBox: "0 0 59 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.72964,
    cy: 40.031,
    r: 5.11764,
    fill: "#30B36B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.4943,
    cy: 40.031,
    r: 5.11764,
    fill: "#30B36B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7588,
    cy: 5.91244,
    r: 5.11764,
    fill: "#30B36B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7298 40.029V21.2644H28.7592V5.48499",
    stroke: "#30B36B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4942 40.0299V21.6917",
    stroke: "#30B36B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTournamentKnockoutTypeNewGreen);
export default __webpack_public_path__ + "static/media/tournament-knockout-type-new-green.129be057a84fb282c7de260aa24f0279.svg";
export { ForwardRef as ReactComponent };